// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"739":"bcad55e2","868":"90ba2398"}[chunkId] + ".chunk.js";
};